<!-- Loading Spinner -->
@if (loadingContent) {
  <div class="spinner-overlay d-flex justify-content-center align-items-center">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'PRODUCTS.CARD.LOADING' | translate }}</span>
    </div>
  </div>
}

<!-- Error State -->
@if (hasError) {
  <div class="error-state text-center p-4">
    <div class="alert alert-danger" role="alert">
      <i class="fas fa-exclamation-triangle mb-2"></i>
      <h5>{{ 'PRODUCTS.CARD.ERROR_TITLE' | translate }}</h5>
      <p>{{ errorMessage }}</p>
      <button class="btn btn-primary" (click)="retryLoadImages()">
        <i class="fas fa-redo me-2"></i>{{ 'PRODUCTS.CARD.TRY_AGAIN' | translate }}
      </button>
    </div>
  </div>
}

<!-- Empty State -->
@if (showEmptyState) {
  <div class="empty-state text-center p-4">
    <div class="alert alert-info" role="alert">
      <i class="fas fa-info-circle mb-2"></i>
      <h5>{{ 'PRODUCTS.CARD.EMPTY_STATE_TITLE' | translate }}</h5>
      <p>{{ 'PRODUCTS.CARD.EMPTY_STATE_MESSAGE' | translate }}</p>
    </div>
  </div>
}

<!-- Carousel with Data -->
@if (hasValidData) {
  <div>
    <div class="product-heading mb-4">
      <h3 class="product-tile text-primary text-uppercase fw-bold">{{ product | translate }}</h3>
    </div>

    <div id="productCarousel" class="carousel slide" data-bs-ride="false">
      <!-- Carousel Inner -->
      <div class="carousel-inner">
        @for (chunk of chunkedImages; track $index; let i = $index) {
          <div class="carousel-item" [class.active]="i === 0">
            <div class="container-fluid">
              <div class="row justify-content-center g-4">
                @for (image of chunk; track image.id) {
                  <div [ngClass]="getColumnClass(chunk.length)">
                    <div class="card h-100 shadow-sm product-card" (click)="goToProductDetails(image)">
                      <img
                        [src]="'data:image/jpg;base64,' + image.imagePath"
                        class="card-img-top p-3"
                        [alt]="('PRODUCTS.CARD.IMAGE_ALT' | translate) + ': ' + image.name"
                        (error)="onImageError($event)" />
                      <div class="card-body d-flex align-items-center justify-content-center">
                        <h5 class="card-title text-center text-break mb-0">{{ image.dryerGroup || image.name | translate }}</h5>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Controls (Arrows) -->
      @if (chunkedImages.length > 1) {
        <button class="carousel-control-prev" type="button" data-bs-target="#productCarousel" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
      }

      @if (chunkedImages.length > 1) {
        <button class="carousel-control-next" type="button" data-bs-target="#productCarousel" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      }
    </div>
  </div>
}
